module.exports = __webpack_public_path__ + "static/media/Pinterest.080da2b4.svg";